export default __webpack_public_path__ + "static/dhruv-bitmoji-6eb21a26625f5cc25f79e2b640d164a5.png";